import { render, staticRenderFns } from "./Translate.vue?vue&type=template&id=1bcfb4d9&scoped=true&"
import script from "./Translate.vue?vue&type=script&lang=js&"
export * from "./Translate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfb4d9",
  null
  
)

export default component.exports